import { IsBoolean, IsDate, IsNotEmpty, IsOptional, IsUUID } from "class-validator";

export class CreateUserToFavouriteEventDto {
	@IsUUID()
	@IsNotEmpty()
	public userId: string;

	@IsUUID()
	@IsNotEmpty()
	public eventId: string;

	@IsDate()
	@IsOptional()
	public eventInstanceDate?: Date;

	@IsBoolean()
	public state: boolean;
}

export class UserToFavouriteEventDto extends CreateUserToFavouriteEventDto {
	id: string;
	createdAt: Date;
}
